export default "__VITE_ASSET__91a67766__"